import { Component } from "react"
import PropTypes from "prop-types"
import { map, filter } from "lodash"
import { Search, Delete } from "@mui/icons-material"
import { Paper, AppBar, Toolbar, InputBase, InputAdornment, List, ListItem, ListItemButton, ListItemText, ListItemSecondaryAction, IconButton } from "@mui/material"
import Loading from "components/material/loading"
import { SEARCH_LIST_ELEM } from "./shapes"
import "./style.scss"

const EMPTY_STATE = {
  search: "",
}

class SearchList extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    noElementDisplay: PropTypes.object.isRequired,
    elements: PropTypes.arrayOf(SEARCH_LIST_ELEM),
    deleteElement: PropTypes.func,
    selectElement: PropTypes.func,
    isLoading: PropTypes.bool,
  }

  constructor(props, ...args) {
    super(props, ...args)
    this.state = EMPTY_STATE
  }

  setSearch = event => {
    this.setState({
      search: event.target.value,
    })
  }

  deleteElement = (id, name) => {
    const { deleteElement } = this.props
    deleteElement(id, name)
  }

  render() {
    const { title, noElementDisplay, selectElement, isLoading } = this.props
    let { elements } = this.props
    const { search } = this.state

    if (search) {
      const lowSearch = search.toLowerCase()
      elements = filter(elements, ({ name }) => name.toLowerCase().includes(lowSearch))
    }

    return <Paper className="components_search-list">
      <AppBar>
        <Toolbar className="search-list-header">
          <h6>{title}</h6>
          <InputBase
            placeholder="Search…"
            value={search}
            onChange={this.setSearch}
            className="search"
            startAdornment={
              <InputAdornment position="start">
                <Search color="inherit" />
              </InputAdornment>
            }
          />
        </Toolbar>
      </AppBar>
      {isLoading ? <div className="loading"><Loading /></div> : <List className="searches">
        {!elements.length && <ListItem>
          <ListItemText
            primary={(noElementDisplay && noElementDisplay.primary) || "Nothing to display."}
            secondary={noElementDisplay && noElementDisplay.secondary}
          />
        </ListItem>}
        {map(elements, elem => <ListItemButton key={elem.id} onClick={() => { selectElement(elem) }}>
          <ListItemText
            primary={elem.header}
            secondary={elem.subheader}
          />
          {elem.allowDelete && <ListItemSecondaryAction>
            <IconButton
              onClick={(event) => {
                event.stopPropagation()
                this.deleteElement(elem.id, elem.name)
              }}
              size="large"
            >
              <Delete />
            </IconButton>
          </ListItemSecondaryAction>}
        </ListItemButton>)}
      </List>}
    </Paper>
  }
}

export default SearchList
